import RoleCharacteristicsFormContainer from './RoleCharacteristicsFormContainer';

export default RoleCharacteristicsFormContainer;
